<template>
  <div class="Searcher surface">
    <searchForm
      v-if="bookingDataResult"
      :bookingData="bookingDataResult"
      :showSimpleForm="showSimpleForm"
      :customUrls="customUrls"
      :selectedSearchData="selectedSearchData"
      :renderSpa="renderSpa"
      :searchIcon="searchIcon"
    >
      <template v-slot:action-button>
        <slot name="action-button"></slot>
      </template>
    </searchForm>
  </div>
</template>
<script>

import axios from 'axios'
import searchForm from './SearchForm'

export default {
  props: {
    showSimpleForm: {
      type: Boolean,
      required: false,
      default: false
    },
    customUrls: {
      type: Object,
      required: false,
      default: () => {}
    },
    selectedSearchData: {
      type: Object,
      required: false,
      default: () => {}
    },
    bookingData: {
      type: Object,
      required: false,
      default: () => {}
    },
    renderSpa: {
      type: String,
      required: false
    },
    searchIcon: {
      type: String,
      required: false,
    }
  },
  components: {
    searchForm
  },
  data: function () {
    return {
      bookingDataResult: false 
    }
  },
  mounted () {
    this.getDataConfig()
  },
  watch: {
    bookingDataResult: function (newData) {
      this.$store.commit('setBookingData', newData)
    }
  },
  methods: {
    getUrl () {
      return (this.customUrls.base? this.customUrls.base + 'searchflight/api/v1/' : this.$store.getters.getConfigUrls.apiUrl)
    },
    getDataConfig () {
        if (this.bookingData)
          this.bookingDataResult = this.bookingData
        else {
          this.$store.commit('setLoading', true)
          axios.defaults.headers.common['Carrier'] = this.$store.getters.getCarrier
          axios.get(this.getUrl() + 'configs/')
            .then((response) => {
              const enabledRoutes = {
                information: response.data.response.simple_routes.information,
                outgoin: response.data.response.simple_routes.routes,
                return: response.data.response.simple_routes.reverse_routes,
                interlinearRoutes: response.data.response.simple_routes.interlinear_routes
              }
              let countrySetting = response.data.response.country_settings.find(x => x.default)
              this.bookingDataResult = {
                roundTrip: response.data.response.journey_type.round_trip,
                roundTripDefault: response.data.response.journey_type.round_trip_default,
                oneWay: response.data.response.journey_type.one_way,
                oneWayDefault: response.data.response.journey_type.one_way_default,
                passengers: response.data.response.passenger_types,
                countrySettings: response.data.response.country_settings,
                countrySetting: countrySetting,
                display_logics: response.data.response.display_logics,
                routes: response.data.response.routes,
                cabin: response.data.response.cabin,
                cookieMessage: response.data.response.privacy_policy,
                temporaryMessage: response.data.response.temporary_message,
                promo: response.data.response.promo,
                session_key: this.$store.getters.getSessionId,
                searchParameters: response.data.response.search_parameters,
                tourcodeList: response.data.response.tourcode_list,
                route_pos_assign_data: response.data.response.route_pos_assign_data,
                enabledRoutes: enabledRoutes
              }
            })
            .catch((error) => {
              console.log('error get config backend', error)
              // this.$router.push('internal-error')
            })
            .finally(() => { this.$store.commit('setLoading', false) })
        }
    }
  }
}
</script>
<style lang="sass">
@import '~core/assets/sass/double-buttons.sass'
\:root
  --searcher-background: var(--color-surface)
.Searcher
  width: 100%
  max-width: 1400px
  margin: 0 auto
  padding: 1rem 1rem 0
  &.surface
    background-color: var(--searcher-background)
    .autocompleteAirport__input div.v-suggest input[type=text]
      background-color: var(--searcher-background) !important
</style>
<style lang="sass">
body.--is-widget
  background-color: transparent !important
  padding-top: 0
.Searcher__formIcon
  min-width: 2.5rem
  padding-right: .5rem
  opacity: .7
  text-align: center
  margin-top: 1.5rem
.form-group
  flex: 1
.Searcher__formInput
  display: flex
  align-items: flex-start
  width: 100%
  padding: 0 0.25rem
.modalfadein-enter-active, .modalfadein-leave-active
  transition: opacity .5s
  .searchForm__passengersForm, .promoCode__modalContainer
    transition: all .2s ease
.modalfadein-enter, .modalfadein-leave-to
  opacity: 0
  .searchForm__passengersForm, .promoCode__modalContainer
    transform: translateY(-5px)
</style>
